/**Dependencies */
import React from "react";

/**Components */
import { Row, Col } from "react-bootstrap";
import Slider from "react-slick";

/**Images */
import vacaciones from "../images2/icons/Vacaciones.png";
import promotions from "../images2/icons/Promociones.png";
import certificate from "../images2/icons/Certificado.png";
import customer from "../images2/icons/Atencionacliente.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
export const SectionAdvise = () => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          autoplay: true,
          autoplaySpeed: 2500,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2500,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2500,
        },
      },
    ],
  };

  return (
    <div className="container">
      <h1
        style={{ fontSize: "30px", color: "#3964ab" }}
        className="text-start pb-3"
      >
        Beneficios de viajar con Agencia Marzah
      </h1>

      <Swiper
        breakpoints={{
          1200: {
            slidesPerView: 4,
            autoplay: true,
            modules: [Autoplay],
            loop: true,
          },
          992: {
            slidesPerView: 3,
            autoplay: true,
            modules: [Autoplay],
            loop: true,
          },
          768: {
            slidesPerView: 2,
            autoplay: true,
            modules: [Autoplay],
            loop: true,
          },
          320: {
            slidesPerView: 1,
            autoplay: true,
            modules: [Autoplay],
            loop: true,
          },
        }}
      >
        <SwiperSlide className="">
          <Row
            className="m-3 p-2 rounded-3"
            style={{
              height: "250px",
              boxShadow: "#3964ab69 4px 5px 20px 0px",
            }}
          >
            <Col
              xs={12}
              className="d-flex justify-content-start align-items-center"
            >
              <img src={vacaciones} alt="" className="me-2" />
              <p
                style={{
                  fontSize: "20px",
                  color: "#3964ab",
                  fontWeight: "600",
                }}
                className="m-0"
              >
                Colecciones por temporada
              </p>
            </Col>
            <Col
              xs={12}
              style={{ overflowY: "auto", maxHeight: "100px", height: "100px" }}
            >
              <p style={{ color: "#3964ab" }}>
                Conoce el mundo y siente la libertad en cada estación del año
                con nuestras colecciones diseñadas especialmente para ti.
              </p>
            </Col>
          </Row>
        </SwiperSlide>
        <SwiperSlide className="">
          <Row
            className="m-3 p-2 rounded-3"
            style={{
              height: "250px",
              boxShadow: "#3964ab69 4px 5px 20px 0px",
            }}
          >
            <Col
              xs={12}
              className="d-flex justify-content-start align-items-center"
            >
              <img src={customer} alt="" className="me-2" />
              <p
                style={{
                  fontSize: "20px",
                  color: "#3964ab",
                  fontWeight: "600",
                }}
                className="m-0"
              >
                Atención al cliente
              </p>
            </Col>
            <Col
              xs={12}
              style={{ overflowY: "auto", maxHeight: "100px", height: "100px" }}
            >
              <p style={{ color: "#3964ab" }}>
                ¿Tienes dudas? Chatea en vivo con nuestro equipo de atención al
                cliente para poder solucionar tus preguntas.
              </p>
            </Col>
          </Row>
        </SwiperSlide>
        <SwiperSlide className="">
          <Row
            className="m-3 p-2 rounded-3"
            style={{
              height: "250px",
              boxShadow: "#3964ab69 4px 5px 20px 0px",
            }}
          >
            <Col
              xs={12}
              className="d-flex justify-content-start align-items-center"
            >
              <img src={promotions} alt="" className="me-2" />
              <p
                style={{
                  fontSize: "20px",
                  color: "#3964ab",
                  fontWeight: "600",
                }}
                className="m-0"
              >
                Ahorra tiempo y dinero
              </p>
            </Col>
            <Col
              xs={12}
              style={{ overflowY: "auto", maxHeight: "100px", height: "100px" }}
            >
              <p style={{ color: "#3964ab" }}>
                Somos una agencia que trabaja de la mano con proveedores para
                poder obtener los mejores productos y precios para nuestros
                usuarios.
              </p>
            </Col>
          </Row>
        </SwiperSlide>
        <SwiperSlide className="">
          <Row
            className="m-3 p-2 rounded-3"
            style={{
              height: "250px",
              boxShadow: "#3964ab69 4px 5px 20px 0px",
            }}
          >
            <Col
              xs={12}
              className="d-flex justify-content-start align-items-center"
            >
              <img src={certificate} alt="" className="me-2" />
              <p
                style={{
                  fontSize: "20px",
                  color: "#3964ab",
                  fontWeight: "600",
                }}
                className="m-0"
              >
                Protección de tus datos
              </p>
            </Col>
            <Col
              xs={12}
              style={{ overflowY: "auto", maxHeight: "100px", height: "100px" }}
            >
              <p style={{ color: "#3964ab" }}>
                Contamos con certificados a nivel federal en protección de
                datos, tu información estará 100% protegida.
              </p>
            </Col>
          </Row>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};
